import { createSystem, defaultConfig } from '@chakra-ui/react'

const config = {
  initialColorMode: 'dark',
  useSystemColorMode: true,
}

export const system = createSystem(defaultConfig, {
  ...config,
  theme: {
    tokens: {
      fonts: {
        body: { value: 'Roboto, sans-serif' },
        header: { value: 'Trebuchet MS, sans-serif' }
      },
      colors: {
        'green': '#2dc937'
      },
    }
  },
  globalCss: {
    "html, body": {
      bg: '#000000',
      color: '#FFFFFF'
    }
  }
})